<script>
    import { createEventDispatcher } from 'svelte';
    import { guidV4 } from '@itslearning/atlas/generate/guid';

    const dispatch = createEventDispatcher();

    /** @type {boolean} */
    export let checked = false;
    /** @type {boolean} */
    export let disabled = false;
    /** @type {string} */
    export let label = undefined;
    /** @type {string} */
    export let id = undefined;
    /** @type {string} */
    export let name = undefined;
    /** @type {boolean} */
    export let labelHidden = false;
    /** @type {boolean} */
    export let small = false;
    /** @type {boolean} */
    export let required = false;
    /** @type {string} */
    export let description = undefined;
    /** @type {string} */
    export let describedBy = undefined;
    /** @type {string} */
    export let elementLegacyColor = '';
    /** @type {string} */
    export let courseColor = '';
    /** @type {string} */
    export let value = '';
    /** @type {boolean} */
    export let hasError = false;
    /** @type {string} */
    export let errorMessage = undefined;

    let checkbox;

    $: disabledClass = disabled ? 'disabled' : '';

    $: smallClass = small ? 'prom-checkbox--small' : '';

    let labelText;

    $: customColor = courseColor ? courseColor : elementLegacyColor;

    $: {
        if (!label || typeof label !== 'string') {
            throw new TypeError('Label must be supplied');
        }

        labelText = label;
    }

    $: labelHiddenClass = labelHidden ? 'screen-reader' : '';
    $: hasErrorClass = hasError ? 'prom-checkbox--has-error' : '';
    $: errorMessageId = id + '__error-message';

    if (description && !describedBy) {
        describedBy = 'prom-checkbox__information_id-' + guidV4();
    }

    /** @private */
    function handleChanged() {
        dispatch('change', { checked });
    }
</script>

<div class="prom-checkbox-wrapper">
    <label class="prom-checkbox {disabledClass} {smallClass} {hasErrorClass}">
        <input
            bind:this={checkbox}
            class="prom-checkbox__input"
            type="checkbox"
            bind:checked
            {disabled}
            {name}
            {value}
            {id}
            {required}
            on:change={handleChanged}
            aria-describedby={description ? describedBy : undefined} />

        <span class="prom-checkbox__custom-check {customColor}"></span>

        <span class="prom-checkbox__label-text {labelHiddenClass}">
            {labelText}
            {#if required}
                <span aria-hidden="true" class="prom-input__required-star">*</span>
            {/if}
        </span>
    </label>

    {#if description}
        <span id={describedBy} class="prom-checkbox__description">
            {description}
        </span>
    {/if}

    <div aria-live="polite" class="prom-error-message prom-error-message--shown" id={errorMessageId}>
        {#if hasError && errorMessage}   
            {errorMessage}
        {/if}
    </div>
</div>
